// index.js or App.js
import React from 'react';
import ReactDOM from 'react-dom';
import './App.css'; // Ensure this import is present
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
